<template>
    <DModal
        :title="__('messages.dashboard.widgets.news.modal.title')"
        :show="showModal"
        is-confirm
        is-big
        is-awaiting-validation
        @confirm="submitMessage"
        @close="emit('close-modal')"
    >
        <div
            v-if="showModal"
            class="m-3 p-3"
        >
            <DFormRow
                :label="__('messages.dashboard.widgets.news.form.message')"
                is-required
                :error="errors?.message"
                is-vertical
            >
                <DRichTextEditor
                    :toolbar="toolbarOptions"
                    :content="oldMessage"
                    @update:content="updateMessage"
                />
                <p
                    v-if="submitSuccess"
                    class="text-success mt-3"
                >
                    {{ __('messages.dashboard.widgets.news.message.success') }}
                </p>
            </DFormRow>
        </div>
    </DModal>
</template>

<script setup>
import { ref } from 'vue'
import { route } from '~@/Composables/route'
import { useForm } from '@inertiajs/vue3'

const props = defineProps({
    showModal: {
        type: Boolean,
        default: false
    },
    oldMessage: {
        type: String,
        default: ''
    }
})

const form = useForm({
    message: JSON.stringify(props.oldMessage, null, 1)
})

const emit = defineEmits(['update:message', 'close-modal'])
const submitSuccess = ref(false)
const errors = ref([])
const toolbarOptions = [
    [{ header: 1 }, { header: 2 }],
    ['bold', 'italic', 'underline', 'link'],
    ['image', 'code-block'],
    [{ indent: '-1' }, { indent: '+1' }],
    [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }]
]

function updateMessage (value) {
    form.message = JSON.stringify(value, null, 1)
}

function submitMessage () {
    form.post(route('widgets.news-widget.create'), {
        onSuccess: () => {
            emit('close-modal')
        },
        onError: (error) => {
            errors.value = error
        },
        preserveState: false
    })
}
</script>
<style>
</style>
